import { z } from "zod";

// Self-signup (passport-web /register → POST /auth/register). first/last are the canonical name and
// REQUIRED + non-blank — display_name is derived from them (sc-89494), never user-typed. The shared
// AuthControllerBase.Register (other products) derives display_name from these too. .regex(/\S/) rejects
// all-whitespace, which .min(1) alone would allow. Lengths mirror passport.users first/last VARCHAR(100).
export const registerRequestSchema = z.object({
  email: z.email("Valid email is required"),
  password: z.string().min(12, "Password must be at least 12 characters"),
  first_name: z.string().min(1, "First name is required").max(100).regex(/\S/, "First name cannot be blank"),
  last_name: z.string().min(1, "Last name is required").max(100).regex(/\S/, "Last name cannot be blank"),
});
